import { CommonAction } from '@/actions/common/common';
import { MyPreferences, createInitialValues, REDIRECT, SUCCESS_REPONSE_CODE, toastr, 
         UNAUTHORIZED_REPONSE_CODE, UNPROCESSABLE_ENTITY_RESPONSE_CODE, handleOtherResponseCode, 
         getIn, WEEKDAYS, INITIAL_VALUES, CustomToastrAction, PageStyle, Field, isCorrectTime, isValidTime, isEqualTime } from '@/imports-files/pages/clients/my-preferences';
import PatternFormat from 'react-number-format';

export async function handleFormSubmit(values, router, formRef, isQuickSetup, setApiError, t)
{
    const body                =   values;
    const result              =   await new MyPreferences().addPreferences(body, isQuickSetup);
    const status_code         =   result.status || result.response.status;
    const customToastrAction   =   new CustomToastrAction();
    setApiError(result.request);


    switch (status_code)
    {
      case SUCCESS_REPONSE_CODE:
        const response = result.data;
        if (response.success)
        {
          customToastrAction.setNormalToastr(response.success, 'success');
          // toastr.success(response.success)
        }
        let new_values = reset_the_initial_values(response, INITIAL_VALUES(t), "submit", t)
        formRef.current.setValues(new_values)
        if(result.data.next_step)
        {
          let next_step = result.data.next_step
          let url = `${REDIRECT.client.quick_setup}${next_step}`;
          (next_step == 'complete') ? router.push(REDIRECT.client.activities) : router.push(url)
        }
        break;
      case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
        return result.response.data.error
        break;
      default:
        handleOtherResponseCode(status_code, router);
    }

}

export function handelChecked(row, formik, id)
{
    formik.values.users.preferences_attributes[id]._destroy = !row.target.checked
    if(row.target.checked){
      formik.values.users.preferences_attributes[id].start_time = '09:00'
      formik.values.users.preferences_attributes[id].end_time = '17:00'
    }
    var parent_element           =   row.target.closest('.MuiTableRow-root');
    var inputs                   =   parent_element.querySelectorAll('input[type="text"]');

    var is_disable_element       =   parent_element.querySelector('.isDisable');
    is_disable_element.value     =   !row.target.checked;
    var event = new Event('input', { bubbles: true });
    is_disable_element.dispatchEvent(event);


    for( let element of inputs)
    {
      if(element.disabled)
      {
        element.disabled = false;
      }
      else
      {
        element.disabled = true;
      }
    }

}

export async function handleDisableValueChange(formik, fieldName)
{
    await formik.setFieldValue(fieldName,  !getIn(formik.values, fieldName));
}

export async function getMyPreferencesData(router, setApiError)
{
    const body = { user_type: "client", step: router.query.step };
    var data = await new MyPreferences().getPreferences(body);
    setApiError(data.request);

    if(data.status == undefined || data.status != 200)
    {
      const error = new Error('An error occurred while fetching the data.')
      error.status = data.response.status
      throw error
    }
    else
    {
      return data.data
    }
}

export function reset_the_initial_values(new_values, initial_values, action, t)
{
    initial_values = createInitialValues(WEEKDAYS(t))
    let new_user_preferences = new_values.users?.preferences_attributes
    initial_values.users.preferences_attributes = initial_values.users.preferences_attributes.map((old_value) => {
      if(new_user_preferences){
        let value = new_user_preferences.filter((x) => x.weekday ==  old_value.weekday)[0]

        if(value && value.weekday == old_value.weekday){
          old_value = value
          old_value.isDisabled = false
          old_value._destroy = false
        }
      }
      else {
              old_value = {
                          isDisabled: true,
                          weekday: old_value.weekday,
                          start_time: '',
                          end_time: '',
                          _destroy: true
                        }
      }
      return old_value
    })
    initial_values.users.client_user_attributes.buffer_before_interview  =  new_values.users.client_user_attributes?.buffer_before_interview;
    initial_values.users.client_user_attributes.buffer_after_interview   =  new_values.users.client_user_attributes?.buffer_after_interview;
    initial_values.users.client_user_attributes.timezone   =  new_values.users.client_user_attributes?.timezone;
    initial_values.users.client_user_attributes.date_format   =  new_values.users.client_user_attributes?.date_format;
    return initial_values;
}

function NumberField({field, className, disabled, format, placeholder}) {
    return <PatternFormat {...field} format="##:##" className={className} name={field.name} disabled={disabled}/>;
  }


export class MyPreferencesAction{
  constructor(setTimePicker){
    this.setTimePicker = setTimePicker;
  }

  options(){
    let arr = []
    for(var i=0; i < 24; i++){
      if(i < 10){
        arr.push("0"+i+":00")
        arr.push("0"+i+":30")
      }
      else{
        arr.push(i+":00")
        arr.push(i+":30")
      }
    }
    return arr
  }

  onSuggestionsClearRequested = () => { this.setTimePicker([])};

  onSuggestionsFetchRequested = async (value) => {
      this.setTimePicker(this.options);
    }

  getSuggestionValue(suggestion)
  {
    return suggestion
  }

  shouldRenderSuggestions(value)
  {
      return value.trim().length >= 1
  }

  renderSuggestion(suggestion)
  {
    return <div> {suggestion}</div>
  }

  renderInputComponent(inputProps, setAutosuggestionFieldValue, selectedValues, setSelectedValues, formik, add_selected_value, params)
  {
    return(<div className="">
      <Field component={NumberField}  className = {PageStyle.Form__Input} autoComplete="password"  {...inputProps} />
    </div>)
  };

  async changePreferenceTime(formik, old_time_zone, new_time_zone){
    let body = formik.values
    body.users.client_user_attributes.old_timezone = old_time_zone
    body.users.client_user_attributes.timezone = new_time_zone
    var data = await new MyPreferences().updateTimeZone(body);
    if(data.status == undefined || data.status != 200)
    {
      const error = new Error('An error occurred while fetching the data.')
      error.status = data.response.status
      throw error
    }
    else
    {
      let old_preferences = formik.values.users.preferences_attributes
      data.data.users.preferences_attributes.map((preference, index)=> {
        if(!old_preferences[index].isDisabled){
          old_preferences[index].start_time = preference.start_time
          old_preferences[index].end_time = preference.end_time
        }
        return preference
      })
      formik.setFieldValue("users.preferences_attributes", old_preferences)
    }
  }

  showCopyOptionIndex(formik){
    let enabled_index;
    length = formik.values?.users?.preferences_attributes?.length || 0
    for(var i = 0; i < length; i++){
      if(!formik.values?.users?.preferences_attributes[i]._destroy)
      {
        enabled_index = i
        break;
      }
    }
    return enabled_index
  }

  async copyTime(formik, day){
    let other_selected_days = 0
    const customToastrAction   =   new CustomToastrAction();
    let start_time = formik.values?.users?.preferences_attributes[day]?.start_time
    let end_time = formik.values?.users?.preferences_attributes[day]?.end_time
    if(isCorrectTime(start_time) && isCorrectTime(end_time) && isEqualTime(start_time, end_time) && isValidTime(start_time, end_time)){
      formik.values?.users?.preferences_attributes?.map((item, index) => {
        if(!item._destroy && (day != index)){
          other_selected_days += 1
          formik.setFieldValue(`users.preferences_attributes[${index}].start_time`, formik.values?.users?.preferences_attributes[day].start_time)
          formik.setFieldValue(`users.preferences_attributes[${index}].end_time`, formik.values?.users?.preferences_attributes[day].end_time)
        }
      })
      if(other_selected_days == 0){
        customToastrAction.setNormalToastr(t('my_preferences:no_more_days'), 'error');
      }
    }
    else{
      await formik.validateForm()
      formik.submitForm();
    }
  }
}